import { version } from './version';
export const DEFAULT_HEADERS = { 'X-Client-Info': `postgrest-js/${version}` };
//# sourceMappingURL=constants.js.map